export default "__VITE_ASSET__ovf9kmCB__"